
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchConsultationById, updateConsultationById, fetchConsultationTypes } from '../../../redux/actions/consultationActions';
import { fetchAnthropometryByPatientId } from '../../../redux/actions/anthropometryActions';
import { fetchDietByPatientId, deleteDietById } from '../../../redux/actions/dietActions';
import { deleteAnthropometryId } from '../../../redux/actions/anthropometryActions';
import { fetchAppointmentDetails } from '../../../redux/actions/appointmentsActions';
import { Formik, Field, Form, FieldArray, ErrorMessage } from 'formik';

import { useModalFeedback } from '../../../context/ModalContext';
import * as Yup from 'yup';
import moment from 'moment';
import Select from 'react-select';
import '../styles/UpdateConsultation.css';
import '../../../styles/ReactSelect.css';
import { clearCurrentDiet } from '../../../redux/slices/dietSlice';
import { Tabs, Tab } from '../../../components/Tabs/Tabs';
import {
  handleKeyDown, onlyNumbers, formatDietName,
  formatDate, calculateFees, tabFieldMapping,
  formatedClassifyBray
} from '../../../utils/functionsFormatPatterns/functionFormatConsultation';
import { MdScale } from 'react-icons/md';
import { FaUserDoctor } from 'react-icons/fa6';
import {
  FaUserMd,
  FaUser,
  FaWeight,
  FaRulerVertical,
  FaCalculator,
  FaPercentage,
  FaCalendar,
  FaPlusCircle,
  FaMinusCircle
} from "react-icons/fa";
import LoadingEllipsis from '../../../components/LoadingEllipsis/LoadingEllipsis';

const UpdateConsultation = () => {
  const location = useLocation();


  const consultationFromState = location.state;
  const { consultation_id: paramConsultationId } = useParams();
  const finalConsultationId = consultationFromState?.consultation_id || paramConsultationId;

  const { currentConsultation, loading, errors } = useSelector((state) => state.consultations);
  const consultation_id = currentConsultation?.consultation_id;
  const patient_id = currentConsultation?.patient_id;
  const appointment_id = currentConsultation?.appointment_id;
  const diet_id = currentConsultation?.diet_id;
  // const { consultation_id, patient_id, appointment_id, diet_id } = location.state || {};
  // const finalConsultationId = consultation_id || paramConsultationId;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedDietId, setSelectedDietId] = useState(null); // ID da dieta selecionada para exclusão
  const [selectedAnthropometryId, setSelectedAnthropometryId] = useState(null); // ID da dieta selecionada para exclusão
  const [deleteType, setDeleteType] = useState(null); // 'anthropometry' ou 'diet'

  const addBtn = "Adicionar";
  const remBtn = "Remover";



  const { currentAppointment: appointmentDetails, loading: appointmentLoading } = useSelector((state) => state.appointments);
  const { currentAnthropometry, loading: anthropometryLoading, errors: anthropometryErrors } = useSelector((state) => state.anthropometry);

  // console.log("Antropometria recebida no update: " + JSON.stringify(anthropometryData));
  const anthropometryData = currentAnthropometry?.[0] || null; // Pega o primeiro item do array, se existir

  const { diets = [], loading: currentDietLoading, error: dietError } = useSelector((state) => state.diets);
  const currentDiet = diets.length > 0 ? diets : [];

  const { consultationTypes = [], typesLoading, typesError } = useSelector(state => state.consultations);

  const [hasInitialized, setHasInitialized] = useState(false);

  const { setIsDeleting, showConfirmation, showInfo, hideModal } = useModalFeedback();


  useEffect(() => {
    return () => {
      dispatch(clearCurrentDiet()); // quando sair da página, limpa
    };
  }, [dispatch]);


  useEffect(() => {
    if (!finalConsultationId || !patient_id || !appointment_id) {
      console.error("Dados insuficientes para carregar a consulta.");
      navigate('/home/consultation/get', { replace: true });
      return;
    }
    dispatch(fetchConsultationById(finalConsultationId));
  }, [dispatch, finalConsultationId, patient_id, appointment_id, diet_id, navigate]);


  useEffect(() => {
    if (currentConsultation?.patient_id) {
      dispatch(fetchDietByPatientId(currentConsultation.patient_id)); // Carrega dietas relacionadas ao paciente
    }
  }, [dispatch, currentConsultation?.patient_id]);

  useEffect(() => {
    if (patient_id) {
      dispatch(fetchAnthropometryByPatientId(patient_id));
    }
  }, [dispatch, patient_id]);



  // useEffect(() => {
  //   console.log("📦 Dados da antropometria carregados:", anthropometryData);
  // }, [anthropometryData]);


  useEffect(() => {
    dispatch(fetchConsultationTypes());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAppointmentDetails(appointment_id));
  }, [dispatch, appointment_id]);

  const [initialValues, setInitialValues] = useState({
    // Dados básicos
    appointment_id: '',
    professional_id: '',
    company_id: '',
    patient_id: '',
    consult_date: '',
    start_time: '',
    end_time: '',
    current_weight: '',
    consult_weight: '',

    // Valores e Taxas/Descontos da consulta
    consultation_type_id: '',
    base_fee: 0,
    additional_charges: 0,
    discounts: 0,
    final_fee: 0,

    // Dados antropométricos
    late_measure: '',
    late_height: '',
    late_weight: '',
    late_bmi: '',
    late_body_fat_percentage: '',
    late_bray_classification: '',

    // Seções da anamnese
    objectiveQ1: '',
    objectiveQ2: '',
    objectiveQ3: '',

    current_illnesses: [''],
    past_illnesses: [''],
    allergies: [''],
    surgeries: [''],
    medications: [''],
    family_history: [''],

    foodHistoryQ1: '',
    foodHistoryQ2: '',
    foodHistoryQ3: '',
    foodHistoryQ4: '',
    foodHistoryQ5: '',
    foodHistoryQ6: '',
    foodHistoryQ7: '',
    foodHistoryQ8: '',
    foodHistoryQ9: '',

    hydrationQ1: '',
    hydrationQ2: '',
    hydrationQ3: '',

    habitsQ1: '',
    habitsQ2: '',
    habitsQ3: '',
    habitsQ4: '',
    habitsQ5: '',

    emotionalFactorsQ1: '',
    emotionalFactorsQ2: '',
    emotionalFactorsQ3: '',
    emotionalFactorsQ4: '',

    supplementsQ1: '',
    supplementsQ2: '',

    expectationsQ1: '',
    expectationsQ2: '',
    expectationsQ3: '',

    // Dados finais
    procedures: '',
    diagnosis: '',
    observations: '',
    diets: []
  });

  useEffect(() => {
    if (!currentConsultation || !currentConsultation.patient_id) return;

    // Verifica se deve atualizar (só se ainda não atualizou OU se o número de dietas mudou)
    const shouldUpdate = !hasInitialized || (currentConsultation?.diets?.length !== initialValues.diets.length);
    if (!shouldUpdate) return;

    // console.log("Dados da consulta carregados:", currentConsultation);


    // Formata os dados da dieta
    const formattedDiets = (currentDiet || []).map((diet) => ({
      ...diet,
      // ...console.log("Valores recebidos da Dieta - currentDiet: ", diet),
      meals: diet.meals?.map((meal) => ({
        ...meal,
        foods: meal.foods || [],
      })) || [],
    }));

    // Carrega os dados da anamnese se existirem
    const anamneseData = currentConsultation.anamnese || {};
    const objectiveData = anamneseData.objective || {};
    const formatedDate = moment(currentConsultation.consult_date).format('YYYY-MM-DD');

    setInitialValues(prev => ({
      ...prev,
      appointment_id: currentConsultation.appointment_id || '',
      professional_id: currentConsultation.professional_id || '',
      company_id: currentConsultation.company_id || '',
      patient_id: currentConsultation.patient_id || '',
      diet_id: currentConsultation.diet_id || '',
      consult_date: formatedDate,
      start_time: currentConsultation.start_time || '',
      end_time: currentConsultation.end_time || '',
      current_weight: currentConsultation.current_weight || '',
      consult_weight: currentConsultation.consult_weight || '',

      // Valores e Taxas/Descontos da consulta
      consultation_type_id: currentConsultation.consultation_type?.consultation_type_id || '',
      base_fee: currentConsultation.current_fee?.base_fee || 0,
      additional_charges: currentConsultation.current_fee?.additional_charges || 0,
      discounts: currentConsultation.current_fee?.discounts || 0,
      final_fee: currentConsultation.current_fee?.final_fee || 0,

      // Anamnese Questions

      objectiveQ1: currentConsultation.objectiveQ1 || '',
      objectiveQ2: currentConsultation.objectiveQ2 || '',
      objectiveQ3: currentConsultation.objectiveQ3 || '',

      current_illnesses: currentConsultation.current_illnesses || [''],
      past_illnesses: currentConsultation.past_illnesses || [''],
      allergies: currentConsultation.allergies || [''],
      surgeries: currentConsultation.surgeries || [''],
      medications: currentConsultation.medications || [''],
      family_history: currentConsultation.family_history || [''],
      diets: formattedDiets,

      foodHistoryQ1: currentConsultation.foodHistoryQ1 || '',
      foodHistoryQ2: currentConsultation.foodHistoryQ2 || '',
      foodHistoryQ3: currentConsultation.foodHistoryQ3 || '',
      foodHistoryQ4: currentConsultation.foodHistoryQ4 || '',
      foodHistoryQ5: currentConsultation.foodHistoryQ5 || '',
      foodHistoryQ6: currentConsultation.foodHistoryQ6 || '',
      foodHistoryQ7: currentConsultation.foodHistoryQ7 || '',
      foodHistoryQ8: currentConsultation.foodHistoryQ8 || '',
      foodHistoryQ9: currentConsultation.foodHistoryQ9 || '',

      hydrationQ1: currentConsultation.hydrationQ1 || '',
      hydrationQ2: currentConsultation.hydrationQ2 || '',
      hydrationQ3: currentConsultation.hydrationQ3 || '',

      habitsQ1: currentConsultation.habitsQ1 || '',
      habitsQ2: currentConsultation.habitsQ2 || '',
      habitsQ3: currentConsultation.habitsQ3 || '',
      habitsQ4: currentConsultation.habitsQ4 || '',
      habitsQ5: currentConsultation.habitsQ5 || '',

      emotionalFactorsQ1: currentConsultation.emotionalFactorsQ1 || '',
      emotionalFactorsQ2: currentConsultation.emotionalFactorsQ2 || '',
      emotionalFactorsQ3: currentConsultation.emotionalFactorsQ3 || '',
      emotionalFactorsQ4: currentConsultation.emotionalFactorsQ4 || '',

      supplementsQ1: currentConsultation.supplementsQ1 || '',
      supplementsQ2: currentConsultation.supplementsQ2 || '',

      expectationsQ1: currentConsultation.expectationsQ1 || '',
      expectationsQ2: currentConsultation.expectationsQ2 || '',
      expectationsQ3: currentConsultation.expectationsQ3 || '',

      // Dados finais
      procedures: currentConsultation.procedures || '',
      diagnosis: currentConsultation.diagnosis || '',
      observations: currentConsultation.observations || '',

    }));
    setHasInitialized(true);
  }, [currentConsultation, currentDiet]);

  // console.log("Objeto Initial Values: " + JSON.stringify(initialValues));

  const validationSchema = Yup.object({
    // Dados básicos da consulta (necessários)
    consult_date: Yup.date().required('Data da consulta é necessário'),
    start_time: Yup.string().required('Hora de início é necessário'),
    consult_weight: Yup.number()
      .transform((value, originalValue) => (originalValue === '' ? undefined : value))
      .min(1, 'Peso inválido'),
    // .required('Peso atual é necessário'),
    // consultation_type_id: Yup.number().required('Tipo de consulta é necessário'),


    // Dados antropométricos (opcionais)
    late_height: Yup.number().min(0, 'Altura inválida'),
    late_weight: Yup.number().min(0, 'Peso inválido'),
    late_bmi: Yup.number().min(0, 'IMC inválido'),
    late_body_fat_percentage: Yup.number().min(0, 'Percentual inválido'),

    // Seção 1: Objetivo da Consulta
    objectiveQ1: Yup.string().required('Campo necessário'),
    // objectiveQ2: Yup.string().required('Campo necessário'),
    // objectiveQ3: Yup.string().required('Campo necessário'),

    // Seção 2: Histórico Clínico
    current_illnesses: Yup.array().of(Yup.string()),
    past_illnesses: Yup.array().of(Yup.string()),
    allergies: Yup.array().of(Yup.string()),
    surgeries: Yup.array().of(Yup.string()),
    medications: Yup.array().of(Yup.string()),
    family_history: Yup.array().of(Yup.string()),

    // Seção 3: Histórico Alimentar
    // foodHistoryQ1: Yup.string().required('Campo necessário'),
    // foodHistoryQ2: Yup.string().required('Campo necessário'),
    // foodHistoryQ3: Yup.string().required('Campo necessário'),
    // foodHistoryQ4: Yup.string().required('Campo necessário'),
    foodHistoryQ5: Yup.string().required('Campo necessário'),
    // foodHistoryQ6: Yup.string().required('Campo necessário'),
    // foodHistoryQ7: Yup.string().required('Campo necessário'),
    // foodHistoryQ8: Yup.string().required('Campo necessário'),
    // foodHistoryQ9: Yup.string().required('Campo necessário'),

    // Seção 4: Hidratação
    // hydrationQ1: Yup.string().required('Campo necessário'),
    // hydrationQ2: Yup.string().required('Campo necessário'),
    hydrationQ3: Yup.string().required('Campo necessário'),

    // Seção 5: Hábitos de Vida
    // habitsQ1: Yup.string().required('Campo necessário'),
    // habitsQ2: Yup.string().required('Campo necessário'),
    // habitsQ3: Yup.string().required('Campo necessário'),
    // habitsQ4: Yup.string().required('Campo necessário'),
    habitsQ5: Yup.string().required('Campo necessário'),

    // Seção 6: Fatores Emocionais
    emotionalFactorsQ1: Yup.string().required('Campo necessário'),
    emotionalFactorsQ2: Yup.string().required('Campo necessário'),
    emotionalFactorsQ3: Yup.string().required('Campo necessário'),
    emotionalFactorsQ4: Yup.string().required('Campo necessário'),

    // Seção 7: Suplementação
    supplementsQ1: Yup.string().required('Campo necessário'),
    // supplementsQ2: Yup.string().required('Campo necessário'),

    // Seção 8: Expectativas
    expectationsQ1: Yup.string().required('Campo necessário'),
    // expectationsQ2: Yup.string().required('Campo necessário'),
    // expectationsQ3: Yup.string().required('Campo necessário'),

    // Seção 9: Dados finais (necessários)
    procedures: Yup.string().required('Procedimentos são necessários'),
    diagnosis: Yup.string().required('Diagnóstico é necessário'),
    observations: Yup.string()
  });


  // console.log("🔍 Antropometria vinculada à consulta:", anthropometryData);

  // Função para iniciar o processo de exclusão (chama o modal de confirmação)
  const initiateDelete = (type, id) => {
    if (!consultation_id || !currentConsultation?.patient_id) {
      showInfo("Erro: dados da consulta estão incompletos.");
      return;
    }

    if (!id) {
      showInfo(`Erro: ID da ${type === 'anthropometry' ? 'Antropometria' : 'Dieta'} não foi fornecido!`);
      return;
    }

    // Aqui não precisa mais de setDeleteType nem os estados separados
    showConfirmation(
      `Tem certeza que deseja remover esta ${type === 'anthropometry' ? 'antropometria' : 'dieta'}?`,
      async () => {
        console.log("🔪 Exclusão confirmada.");
        console.log("Tipo: ", type);
        console.log("ID: ", id);

        setIsDeleting(true);
        try {
          if (type === 'anthropometry') {
            await dispatch(deleteAnthropometryId(id));
            showInfo('Antropometria removida com sucesso!');
          } else {
            await dispatch(deleteDietById(id));
            showInfo('Dieta removida com sucesso!');
            if (currentConsultation?.patient_id) {
              dispatch(fetchDietByPatientId(currentConsultation.patient_id));
            }
          }

          if (consultation_id) {
            navigate(`/home/consultation/update/${consultation_id}`);
          }


        } catch (error) {
          showInfo(`Erro ao excluir ${type === 'anthropometry' ? 'a antropometria' : 'a dieta'}.`);
          console.error(error);
        } finally {
          setIsDeleting(false);
        }
      },
      handleCancelDelete
    );
  };

  const handleCancelDelete = () => {
    setSelectedAnthropometryId(null);
    setSelectedDietId(null);
    setDeleteType(null);
    hideModal(true);
  };

  const handleNewAnthropometry = () => {
    if (currentConsultation?.patient_id) {
      navigate('/home/anthropometry/create', {
        state: {
          appointment_id,
          patient_id: currentConsultation?.patient_id,
          professional_id: currentConsultation?.professional_id,
          consultation_id: currentConsultation?.consultation_id,
        }
      });
      // console.log(appointmentDetails.patient_id);
    } else {
      alert('Paciente não encontrado.');
    }
  };


  const tabHasErrors = (label) => {
    if (!errors || !tabFieldMapping[label]) return false;
    return tabFieldMapping[label].some(field => !!errors[field]);
  };

  const renderTabLabel = (index, label, errors) => {
    return tabHasErrors(index, errors)
      ? <span style={{ color: 'red', fontWeight: 'bold' }}>{label}</span>
      : label;
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // console.log("🟢 handleSubmit chamado", values); 
    try {
      const anamneseData = {
        version: "1.0",
        objective: {
          q1: values.objectiveQ1 || '',
          q2: values.objectiveQ2 || '',
          q3: values.objectiveQ3 || ''
        },
        clinicalHistory: {
          currentIllnesses: values.current_illnesses.filter(i => i.trim() !== ''),
          pastIllnesses: values.past_illnesses.filter(i => i.trim() !== ''),
          allergies: values.allergies.filter(i => i.trim() !== ''),
          surgeries: values.surgeries.filter(i => i.trim() !== ''),
          medications: values.medications.filter(i => i.trim() !== ''),
          familyHistory: values.family_history.filter(i => i.trim() !== ''),
        },
        foodHistory: {
          q1: values.foodHistoryQ1 || '',
          q2: values.foodHistoryQ2 || '',
          q3: values.foodHistoryQ3 || '',
          q4: values.foodHistoryQ4 || '',
          q5: values.foodHistoryQ5 || '',
          q6: values.foodHistoryQ6 || '',
          q7: values.foodHistoryQ7 || '',
          q8: values.foodHistoryQ8 || '',
          q9: values.foodHistoryQ9 || ''
        },
        hydration: {
          q1: values.hydrationQ1 || '',
          q2: values.hydrationQ2 || '',
          q3: values.hydrationQ3 || ''
        },
        habits: {
          q1: values.habitsQ1 || '',
          q2: values.habitsQ2 || '',
          q3: values.habitsQ3 || '',
          q4: values.habitsQ4 || '',
          q5: values.habitsQ5 || ''
        },
        emotionalFactors: {
          q1: values.emotionalFactorsQ1 || '',
          q2: values.emotionalFactorsQ2 || '',
          q3: values.emotionalFactorsQ3 || '',
          q4: values.emotionalFactorsQ4 || ''
        },
        supplementation: {
          q1: values.supplementsQ1 || '',
          q2: values.supplementsQ2 || ''
        },
        expectations: {
          q1: values.expectationsQ1 || '',
          q2: values.expectationsQ2 || '',
          q3: values.expectationsQ3 || ''
        }
      };

      const payload = {
        ...values,
        anamnese: anamneseData,
        current_illnesses: values.current_illnesses.filter(i => i.trim() !== ''),
        past_illnesses: values.past_illnesses.filter(i => i.trim() !== ''),
        allergies: values.allergies.filter(i => i.trim() !== ''),
        surgeries: values.surgeries.filter(i => i.trim() !== ''),
        medications: values.medications.filter(i => i.trim() !== ''),
        family_history: values.family_history.filter(i => i.trim() !== ''),
      };

      await dispatch(updateConsultationById({ consultation_id, data: payload }));

      showInfo('Consulta atualizada com sucesso!');
      setTimeout(() => {
        resetForm();
        navigate(`/home/consultation/show/${consultation_id}`);
      }, 2000);
    } catch (error) {
      console.error("Erro ao atualizar consulta:", error);
      showInfo(`Erro ao tentar deletar: ${error}` || error.message || 'Erro ao atualizar a consulta.', 3000);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!appointment_id) {
      console.error('Erro: appointment_id não foi fornecido!');
    }
    if (!patient_id) {
      console.error('Erro: patient_id não foi fornecido!');
    }
    if (!consultation_id) {
      console.error('Erro: consultation_id não foi fornecido!');
    }
  }, [appointment_id, patient_id, consultation_id]);

  if (loading) return <LoadingEllipsis message='Carregando Consulta' />;
  if (errors) return <div>Erro: {errors}</div>;
  if (!initialValues.consult_date) {
    return <LoadingEllipsis message='Carregando dados do formulário' />;
  }

  return (
    <div className="consultationMain">
      <h3>Atualizar Consulta</h3>

      {/* {appointment_id ? (
        <div>Relacionado ao Agendamento:
          <div>Agendamento id: {appointment_id}</div>
          <div>Paciente id: {patient_id}</div>
          <div>Consulta id: {consultation_id}</div>
          <div>Diet id: {currentDiet.diet_id || diet_id}</div>
        </div>
      ) : (
        <p>Esta Atualização Consulta não possui um ID de agendamento fornecido.</p>
      )}

      {!appointment_id || !patient_id || !consultation_id ? (
        <div style={{ color: 'red' }}>
          ⚠️ Dados essenciais ausentes:<br />
          Agendamento ID: {appointment_id || '❌'}<br />
          Paciente ID: {patient_id || '❌'}<br />
          Consulta ID: {consultation_id || '❌'}
        </div>
      ) : (
        <div>
          ✅ Consulta pronta:<br />
          Agendamento ID: {appointment_id}<br />
          Paciente ID: {patient_id}<br />
          Consulta ID: {consultation_id}
        </div>
      )} */}


      <div className="consultationForm">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
          errors
          touched
        >
          {({ isSubmitting, errors, touched, setFieldValue, values }) => (
            <Form onKeyDown={handleKeyDown}>
              {/* Anamnese */}
              <h3 className='askTitle'><FaUserDoctor className='icon' /> / <FaUser className='icon' /> Nessa Consulta (Anamnese)</h3>
              <Tabs errors={errors} tabFieldMapping={tabFieldMapping}>
                <Tab label="Nessa Consulta">
                  <div className="consultationLine">
                    <div className="consultation-form-group">
                      <label>Data da Consulta:</label>
                      <Field type="date" id="consultation_date" name="consult_date" />
                      {errors.consult_date && touched.consult_date && <div className="error">{errors.consult_date}</div>}
                    </div>

                    <div className="consultation-form-group">
                      <label>Hora de Início:</label>
                      <Field type="time" id="consultation_time" name="start_time" />
                      {errors.start_time && touched.start_time && <div className="error">{errors.start_time}</div>}
                    </div>

                    <div className="consultation-form-group">
                      <label htmlFor="consultation_type_id">Tipo de Consulta:</label>
                      {typesLoading ? (
                        <div>Carregando tipos de consulta...</div>
                      ) : typesError ? (
                        <div className="error">Erro ao carregar tipos: {typesError}</div>
                      ) : (
                        <Select
                          name="consultation_type_id"
                          options={consultationTypes.map(type => ({
                            value: type.consultation_type_id,
                            label: `${type.name} (R$ ${type.default_fee.toFixed(2)})`,
                            fee: type.default_fee // Podemos armazenar a taxa para uso posterior
                          }))}
                          value={
                            consultationTypes
                              .map(type => ({
                                value: type.consultation_type_id,
                                label: `${type.name} (R$ ${type.default_fee.toFixed(2)})`,
                                fee: type.default_fee
                              }))
                              .find(option => option.value === values.consultation_type_id) || null
                          }
                          onChange={(selectedOption) => {
                            setFieldValue('consultation_type_id', selectedOption.value);
                            setFieldValue('base_fee', selectedOption.fee);
                            setFieldValue('final_fee', calculateFees(selectedOption.fee, values.additional_charges, values.discounts));
                          }}

                          placeholder="Selecione o tipo de consulta"
                          noOptionsMessage={() => "Nenhum tipo disponível"}
                          classNamePrefix="custom-select"
                        />
                      )}
                      {errors.start_time && touched.consultation_type_id && <div className="error">{errors.consultation_type_id}</div>}
                      <ErrorMessage name="consultation_type_id" component="div" className="error" />
                    </div>

                  </div>
                  <div className="consultationLine">
                    <div className="consultationLine">
                      {/* Campo Taxa Base */}
                      <div className="consultation-form-group">
                        <label>Taxa Base (R$)</label>
                        <Field
                          name="base_fee"
                          onBlur={(e) => {
                            const value = parseFloat(e.target.value) || 0;
                            setFieldValue('base_fee', value.toFixed(2));
                            setFieldValue('final_fee', calculateFees(
                              value,
                              values.additional_charges,
                              values.discounts
                            ));
                          }}
                          onChange={(e) => {
                            // Permite digitação livre, só formata no blur
                            setFieldValue('base_fee', e.target.value);
                          }}
                          value={values.base_fee}
                          type="number"
                          step="5.00"
                          className="form-control"
                        />
                      </div>

                      {/* Campo Encargos Adicionais */}
                      <div className="consultation-form-group">
                        <label>Encargos Adicionais (R$)</label>
                        <Field
                          name="additional_charges"
                          onBlur={(e) => {
                            const value = parseFloat(e.target.value) || 0;
                            setFieldValue('additional_charges', value.toFixed(2));
                            setFieldValue('final_fee', calculateFees(
                              values.base_fee,
                              value,
                              values.discounts
                            ));
                          }}
                          onChange={(e) => {
                            setFieldValue('additional_charges', e.target.value);
                          }}
                          value={values.additional_charges}
                          type="number"
                          step="5.00"
                          className="form-control"
                        />
                      </div>

                      {/* Campo Descontos */}
                      <div className="consultation-form-group">
                        <label>Descontos (R$)</label>
                        <Field
                          name="discounts"
                          onBlur={(e) => {
                            const value = parseFloat(e.target.value) || 0;
                            setFieldValue('discounts', value.toFixed(2));
                            setFieldValue('final_fee', calculateFees(
                              values.base_fee,
                              values.additional_charges,
                              value
                            ));
                          }}
                          onChange={(e) => {
                            setFieldValue('discounts', e.target.value);
                          }}
                          value={values.discounts}
                          type="number"
                          step="5.00"
                          className="form-control"
                        />
                      </div>

                      {/* Campo Valor Final (somente leitura) */}
                      <div className="consultation-form-group">
                        <label>Valor Final (R$)</label>
                        <Field
                          name="final_fee"
                          type="text"
                          value={parseFloat(values.final_fee || 0).toFixed(2)}
                          readOnly
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </Tab>
                {/* Objetivo da Consulta */}
                <Tab label='1 Objetivo da Consulta'>
                  <div className="consultation-form-group">
                    <h3 className='askTitle'><span className='askSpan'>1</span> Objetivo da Consulta</h3>
                    <div className="consultationLineQuestion elementHidden">
                      <label htmlFor="consult_weight">Peso Atual (kg):</label>
                      <Field
                        type="number"
                        name="consult_weight"
                        id="consult_weight"
                        className="fieldInput"
                        onKeyDown={(e) => onlyNumbers(e, setFieldValue, 'consult_weight')}
                      />
                      {errors.consult_weight && touched.consult_weight && <div className="error">{errors.consult_weight}</div>}
                    </div>
                  </div>
                  <div className="consultation-form-group">
                    <div className="consultationLineQuestion">
                      <label htmlFor="objectiveQ1">Qual o motivo principal que trouxe você aqui?</label>
                      <Field
                        type="text"
                        name="objectiveQ1"
                        id="objectiveQ1"
                        className="fieldInput"
                      />
                      {errors.objectiveQ1 && touched.objectiveQ1 && <div className="error">{errors.objectiveQ1}</div>}
                    </div>
                    <div className="consultationLineQuestion">
                      <label htmlFor="objectiveQ2">Tem alguma meta específica? (Ex.: emagrecimento, ganho de massa, melhora da saúde, controle de doenças, etc.)</label>
                      <Field
                        type="text"
                        name="objectiveQ2"
                        id="objectiveQ2"
                        className="fieldInput"
                      />
                      {errors.objectiveQ2 && touched.objectiveQ2 && <div className="error">{errors.objectiveQ2}</div>}
                    </div>
                    <div className="consultationLineQuestion">
                      <label htmlFor="objectiveQ3">Tem alguma dificuldade específica com sua alimentação?</label>
                      <Field
                        type="text"
                        name="objectiveQ3"
                        id="objectiveQ3"
                        className="fieldInput"
                      />
                      {errors.objectiveQ3 && touched.objectiveQ3 && <div className="error">{errors.objectiveQ3}</div>}
                    </div>
                  </div>
                </Tab>
                {/* Histórico Clínico Familiar */}
                <Tab label="2 Histórico Clínico Familiar">
                  <h3 className='askTitle'><span className='askSpan'>2</span> Histórico Clínico Familiar</h3>
                  <div className="consultation-form-group">
                    {/* Arrays de Campos (Ex.: Doenças Atuais) */}
                    <div className="consultation-form-group">
                      <label>Doenças Atuais:</label>
                      <FieldArray name="current_illnesses">
                        {({ push, remove }) => (
                          <div>
                            {values.current_illnesses && values.current_illnesses.length > 0 ? (
                              values.current_illnesses.map((illness, index) => (
                                <div key={index} className="consultationLine">
                                  <Field
                                    type="text"
                                    name={`current_illnesses[${index}]`}
                                    placeholder={`Doença ${index + 1}`}
                                  />
                                  <button className='btnIcoAddRm' type="button" onClick={() => push('')} data-tip={addBtn}>
                                    <FaPlusCircle className='iconPlus' />
                                  </button>
                                  <button className='btnIcoAddRm' type="button" onClick={() => remove(index)} data-tip={remBtn}>
                                    <FaMinusCircle className='iconMinus' />
                                  </button>
                                </div>
                              ))
                            ) : (
                              <>
                                <p>Nenhuma doença atual adicionada.</p>
                                <button className='btnIcoAddRm' type="button" onClick={() => push('')} data-tip={addBtn}>
                                  <FaPlusCircle className='iconPlus' />
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </FieldArray>
                      {errors.current_illnesses && touched.current_illnesses && (
                        <div className="error-message">{errors.current_illnesses}</div>
                      )}
                    </div>

                    {/* Doenças Prévias ou Crônicas */}
                    <div className="consultation-form-group">
                      <label>Doenças Prévias ou Crônicas</label>
                      <FieldArray name="past_illnesses" id="past_illnesses">
                        {({ push, remove }) => (
                          <div>
                            {values.past_illnesses && values.past_illnesses.length > 0 ? (
                              values.past_illnesses.map((illness, index) => (
                                <div key={index} className="consultationLine">
                                  <Field
                                    type="text"
                                    name={`past_illnesses[${index}]`}
                                    placeholder={`Doença ${index + 1}`}
                                  />
                                  <button className='btnIcoAddRm' type="button" onClick={() => push('')} data-tip={addBtn}>
                                    <FaPlusCircle className='iconPlus' />
                                  </button>
                                  <button className='btnIcoAddRm' type="button" onClick={() => remove(index)} data-tip={remBtn}>
                                    <FaMinusCircle className='iconMinus' />
                                  </button>
                                </div>
                              ))
                            ) : (
                              <>
                                <p>Nenhuma Doença Prévias ou Crônicas.</p>
                                <button className='btnIcoAddRm' type="button" onClick={() => push('')} data-tip={addBtn}>
                                  <FaPlusCircle className='iconPlus' />
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </FieldArray>
                      {errors.past_illnesses && touched.past_illnesses && (
                        <div className="error-message">{errors.past_illnesses}</div>
                      )}
                    </div>

                    {/* Alergias e Intolerâncias */}
                    <div className="consultation-form-group">
                      <label>Alergias e Intolerâncias</label>
                      <FieldArray name="allergies" id="allergies">
                        {({ push, remove }) => (
                          <div>
                            {values.allergies && values.allergies.length > 0 ? (
                              values.allergies.map((allergy, index) => (
                                <div key={index} className="consultationLine">
                                  <Field
                                    type="text"
                                    name={`allergies[${index}]`}
                                    placeholder={`Alergia ${index + 1}`}
                                  />
                                  <button className="btnIcoAddRm" type="button" onClick={() => push('')} data-tip={addBtn}>
                                    <FaPlusCircle className="iconPlus" />
                                  </button>
                                  <button className="btnIcoAddRm" type="button" onClick={() => remove(index)} data-tip={remBtn}>
                                    <FaMinusCircle className="iconMinus" />
                                  </button>
                                </div>
                              ))
                            ) : (
                              <>
                                <p>Nenhuma alergia adicionada.</p>
                                <button className="btnIcoAddRm" type="button" onClick={() => push('')} data-tip={addBtn}>
                                  <FaPlusCircle className="iconPlus" />
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </FieldArray>
                      {errors.allergies && touched.allergies && (
                        <div className="error-message">{errors.allergies}</div>
                      )}
                    </div>

                    {/* Cirurgias e Hospitalizações */}
                    <div className="consultation-form-group">
                      <label>Cirurgias e Hospitalizações</label>
                      <FieldArray name="surgeries" id="surgeries">
                        {({ push, remove }) => (
                          <div>
                            {values.surgeries && values.surgeries.length > 0 ? (
                              values.surgeries.map((surgery, index) => (
                                <div key={index} className="consultationLine">
                                  <Field
                                    type="text"
                                    name={`surgeries[${index}]`}
                                    placeholder={`Cirurgia ${index + 1}`}
                                  />
                                  <button className="btnIcoAddRm" type="button" onClick={() => push('')} data-tip={addBtn}>
                                    <FaPlusCircle className="iconPlus" />
                                  </button>
                                  <button className="btnIcoAddRm" type="button" onClick={() => remove(index)} data-tip={remBtn}>
                                    <FaMinusCircle className="iconMinus" />
                                  </button>
                                </div>
                              ))
                            ) : (
                              <>
                                <p>Nenhuma cirurgia ou hospitalização adicionada.</p>
                                <button className="btnIcoAddRm" type="button" onClick={() => push('')} data-tip={addBtn}>
                                  <FaPlusCircle className="iconPlus" />
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </FieldArray>
                      {errors.surgeries && touched.surgeries && (
                        <div className="error-message">{errors.surgeries}</div>
                      )}
                    </div>

                    {/* Uso de Medicamentos */}
                    <div className="consultation-form-group">
                      <label>Uso de Medicamentos</label>
                      <FieldArray name="medications" id="medications">
                        {({ push, remove }) => (
                          <div>
                            {values.medications && values.medications.length > 0 ? (
                              values.medications.map((medication, index) => (
                                <div key={index} className="consultationLine">
                                  <Field
                                    type="text"
                                    name={`medications[${index}]`}
                                    placeholder={`Medicamento ${index + 1}`}
                                  />
                                  <button className="btnIcoAddRm" type="button" onClick={() => push('')} data-tip={addBtn}>
                                    <FaPlusCircle className="iconPlus" />
                                  </button>
                                  <button className="btnIcoAddRm" type="button" onClick={() => remove(index)} data-tip={remBtn}>
                                    <FaMinusCircle className="iconMinus" />
                                  </button>
                                </div>
                              ))
                            ) : (
                              <>
                                <p>Nenhum medicamento adicionado.</p>
                                <button className="btnIcoAddRm" type="button" onClick={() => push('')} data-tip={addBtn}>
                                  <FaPlusCircle className="iconPlus" />
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </FieldArray>
                      {errors.medications && touched.medications && (
                        <div className="error-message">{errors.medications}</div>
                      )}
                    </div>

                    {/* Histórico Familiar */}
                    <div className="consultation-form-group">
                      <label>Histórico Familiar</label>
                      <FieldArray name="family_history" id="family_history">
                        {({ push, remove }) => (
                          <div>
                            {values.family_history && values.family_history.length > 0 ? (
                              values.family_history.map((history, index) => (
                                <div key={index} className="consultationLine">
                                  <Field
                                    type="text"
                                    name={`family_history[${index}]`}
                                    placeholder={`Histórico ${index + 1}`}
                                  />
                                  <button className="btnIcoAddRm" type="button" onClick={() => push('')} data-tip={addBtn}>
                                    <FaPlusCircle className="iconPlus" />
                                  </button>
                                  <button className="btnIcoAddRm" type="button" onClick={() => remove(index)} data-tip={remBtn}>
                                    <FaMinusCircle className="iconMinus" />
                                  </button>
                                </div>
                              ))
                            ) : (
                              <>
                                <p>Nenhum histórico familiar adicionado.</p>
                                <button className="btnIcoAddRm" type="button" onClick={() => push('')} data-tip={addBtn}>
                                  <FaPlusCircle className="iconPlus" />
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </FieldArray>
                      {errors.family_history && touched.family_history && (
                        <div className="error-message">{errors.family_history}</div>
                      )}
                    </div>
                  </div>

                </Tab>
                {/* Histórico Alimentar */}
                <Tab label="3 - Histórico Alimentar">
                  <div className="consultation-form-group">
                    <h3 className='askTitle'><span className='askSpan'>3</span> Histórico Alimentar</h3>
                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ1">Quantas refeições faz ao dia?</label>
                      <Field
                        type="text"
                        name="foodHistoryQ1"
                        id="foodHistoryQ1"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ1 && touched.foodHistoryQ1 && <div className="error">{errors.foodHistoryQ1}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ2">Costuma pular alguma refeição?</label>
                      <Field
                        type="text"
                        name="foodHistoryQ2"
                        id="foodHistoryQ2"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ2 && touched.foodHistoryQ2 && <div className="error">{errors.foodHistoryQ2}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ3">Como é o seu café da manhã, almoço e jantar? (Ex.: horário, composição dos pratos, quantidade)</label>
                      <Field
                        type="text"
                        name="foodHistoryQ3"
                        id="foodHistoryQ3"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ3 && touched.foodHistoryQ3 && <div className="error">{errors.foodHistoryQ3}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ4">Consome lanches entre as refeições? O que costuma comer?</label>
                      <Field
                        type="text"
                        name="foodHistoryQ4"
                        id="foodHistoryQ4"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ4 && touched.foodHistoryQ4 && <div className="error">{errors.foodHistoryQ4}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ5">Prefere alimentos doces ou salgados?</label>
                      <Field
                        type="text"
                        name="foodHistoryQ5"
                        id="foodHistoryQ5"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ5 && touched.foodHistoryQ5 && <div className="error">{errors.foodHistoryQ5}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ6">Qual a frequência de consumo de fast food e ultraprocessados?</label>
                      <Field
                        type="text"
                        name="foodHistoryQ6"
                        id="foodHistoryQ6"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ6 && touched.foodHistoryQ6 && <div className="error">{errors.foodHistoryQ6}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ7">Tem alguma restrição alimentar (ética, religiosa, voluntária)?</label>
                      <Field
                        type="text"
                        name="foodHistoryQ7"
                        id="foodHistoryQ7"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ7 && touched.foodHistoryQ7 && <div className="error">{errors.foodHistoryQ7}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ8">Sabe cozinhar? Com que frequência prepara suas refeições?</label>
                      <Field
                        type="text"
                        name="foodHistoryQ8"
                        id="foodHistoryQ8"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ8 && touched.foodHistoryQ8 && <div className="error">{errors.foodHistoryQ8}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="foodHistoryQ9">Costuma comer fora ou pedir delivery?</label>
                      <Field
                        type="text"
                        name="foodHistoryQ9"
                        id="foodHistoryQ9"
                        className="fieldInput"
                      />
                      {errors.foodHistoryQ9 && touched.foodHistoryQ9 && <div className="error">{errors.foodHistoryQ9}</div>}
                    </div>
                  </div>
                </Tab>
                {/*Hidratação  */}
                <Tab label="4 - Hidratação">
                  <div className="consultation-form-group">
                    <h3 className='askTitle'><span className='askSpan'>4</span> Hidratação</h3>

                    <div className="consultationLineQuestion">
                      <label htmlFor="hydrationQ1">Quantos litros de água consome por dia?</label>
                      <Field
                        type="text"
                        name="hydrationQ1"
                        id="hydrationQ1"
                        className="fieldInput"
                      />
                      {errors.hydrationQ1 && touched.hydrationQ1 && <div className="error">{errors.hydrationQ1}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="hydrationQ2">Bebe outras bebidas com frequência? (Refrigerantes, sucos industrializados, álcool, etc.)</label>
                      <Field
                        type="text"
                        name="hydrationQ2"
                        id="hydrationQ2"
                        className="fieldInput"
                      />
                      {errors.hydrationQ2 && touched.hydrationQ2 && <div className="error">{errors.hydrationQ2}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="hydrationQ3">Sente sede constantemente?</label>
                      <Field
                        type="text"
                        name="hydrationQ3"
                        id="hydrationQ3"
                        className="fieldInput"
                      />
                      {errors.hydrationQ3 && touched.hydrationQ3 && <div className="error">{errors.hydrationQ3}</div>}
                    </div>
                  </div>
                </Tab>
                {/* `Hábitos de Vida e Rotina */}
                <Tab label="5 - Hábitos de Vida e Rotina">
                  <div className="consultation-form-group">
                    <h3 className='askTitle'><span className='askSpan'>5</span> Hábitos de Vida e Rotina</h3>

                    <div className="consultationLineQuestion">
                      <label htmlFor="habitsQ1">Pratica atividade física? (Qual, frequência e intensidade?)</label>
                      <Field
                        type="text"
                        name="habitsQ1"
                        id="habitsQ1"
                        className="fieldInput"
                      />
                      {errors.habitsQ1 && touched.habitsQ1 && <div className="error">{errors.habitsQ1}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="habitsQ2">Como é seu nível de estresse diário?</label>
                      <Field
                        type="text"
                        name="habitsQ2"
                        id="habitsQ2"
                        className="fieldInput"
                      />
                      {errors.habitsQ2 && touched.habitsQ2 && <div className="error">{errors.habitsQ2}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="habitsQ3">Como avalia seu sono? (Horas dormidas, qualidade do sono)</label>
                      <Field
                        type="text"
                        name="habitsQ3"
                        id="habitsQ3"
                        className="fieldInput"
                      />
                      {errors.habitsQ3 && touched.habitsQ3 && <div className="error">{errors.habitsQ3}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="habitsQ4">Tem horários regulares para refeições e descanso?</label>
                      <Field
                        type="text"
                        name="habitsQ4"
                        id="habitsQ4"
                        className="fieldInput"
                      />
                      {errors.habitsQ4 && touched.habitsQ4 && <div className="error">{errors.habitsQ4}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="habitsQ5">Faz uso de álcool ou tabaco?</label>
                      <Field
                        type="text"
                        name="habitsQ5"
                        id="habitsQ5"
                        className="fieldInput"
                      />
                      {errors.habitsQ5 && touched.habitsQ5 && <div className="error">{errors.habitsQ5}</div>}
                    </div>
                  </div>
                </Tab>
                {/* Fatores Emocionais e Comportamentais */}
                <Tab label="6 - Fatores Emocionais / Comportamentais">
                  <div className="consultation-form-group">
                    <h3 className='askTitle'><span className='askSpan'>6</span> Fatores Emocionais e Comportamentais</h3>

                    <div className="consultationLineQuestion">
                      <label htmlFor="emotionalFactorsQ1">Sente ansiedade ou compulsão alimentar?</label>
                      <Field as="select" name="emotionalFactorsQ1" className="fieldInput">
                        <option value="">Selecione...</option>
                        <option value="nunca">Nunca</option>
                        <option value="raramente">Raramente</option>
                        <option value="as_vezes">Às vezes</option>
                        <option value="frequentemente">Frequentemente</option>
                        <option value="sempre">Sempre</option>
                      </Field>
                      {errors.emotionalFactorsQ1 && touched.emotionalFactorsQ1 && <div className="error">{errors.emotionalFactorsQ1}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="emotionalFactorsQ2">Costuma comer por impulso ou emocionalmente?</label>
                      <Field as="select" name="emotionalFactorsQ2" className="fieldInput">
                        <option value="">Selecione...</option>
                        <option value="nunca">Nunca</option>
                        <option value="raramente">Raramente</option>
                        <option value="as_vezes">Às vezes</option>
                        <option value="frequentemente">Frequentemente</option>
                        <option value="sempre">Sempre</option>
                      </Field>
                      {errors.emotionalFactorsQ2 && touched.emotionalFactorsQ2 && <div className="error">{errors.emotionalFactorsQ2}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="emotionalFactorsQ3">Tem momentos de exagero alimentar? (Ex.: comer muito à noite, beliscar constantemente)</label>
                      <Field as="select" name="emotionalFactorsQ3" className="fieldInput">
                        <option value="">Selecione...</option>
                        <option value="nunca">Nunca</option>
                        <option value="raramente">Raramente</option>
                        <option value="as_vezes">Às vezes</option>
                        <option value="frequentemente">Frequentemente</option>
                        <option value="sempre">Sempre</option>
                      </Field>
                      {errors.emotionalFactorsQ3 && touched.emotionalFactorsQ3 && <div className="error">{errors.emotionalFactorsQ3}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="emotionalFactorsQ4">Tem algum hábito alimentar que gostaria de mudar?</label>
                      <Field
                        type="text"
                        name="emotionalFactorsQ4"
                        id="emotionalFactorsQ4"
                        className="fieldInput"
                      />
                      {errors.emotionalFactorsQ4 && touched.emotionalFactorsQ4 && <div className="error">{errors.emotionalFactorsQ4}</div>}
                    </div>
                  </div>
                </Tab>
                {/* Suplementação e Consumo de Vitaminas */}
                <Tab label="7 - Suplementação e Vitaminas">
                  <div className="consultation-form-group">
                    <h3 className='askTitle'><span className='askSpan'>7</span> Suplementação e Consumo de Vitaminas</h3>

                    <div className="consultationLineQuestion">
                      <label htmlFor="supplementsQ1">Faz uso de suplementos? (Proteína, ômega-3, vitaminas, etc.)</label>
                      <Field
                        as="select"
                        name="supplementsQ1"
                        id="supplementsQ1"
                        className="fieldInput"
                      >
                        <option value="">Selecione...</option>
                        <option value="sim">Sim</option>
                        <option value="nao">Não</option>
                        <option value="ocasionalmente">Ocasionalmente</option>
                      </Field>
                      {errors.supplementsQ1 && touched.supplementsQ1 && <div className="error">{errors.supplementsQ1}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="supplementsQ2">Tem alguma orientação médica ou nutricional para o uso?</label>
                      <Field
                        as="select"
                        name="supplementsQ2"
                        id="supplementsQ2"
                        className="fieldInput"
                      >
                        <option value="">Selecione...</option>
                        <option value="sim_medica">Sim, médica</option>
                        <option value="sim_nutricional">Sim, nutricional</option>
                        <option value="nao">Não</option>
                        <option value="auto">Autoprescrição</option>
                      </Field>
                      {errors.supplementsQ2 && touched.supplementsQ2 && <div className="error">{errors.supplementsQ2}</div>}
                    </div>
                  </div>
                </Tab>
                {/* Plano e Expectativa */}
                <Tab label="8 - Planos e Expectativas">
                  <div className="consultation-form-group">
                    <h3 className='askTitle'><span className='askSpan'>8</span> Plano e Expectativas</h3>

                    <div className="consultationLineQuestion">
                      <label htmlFor="expectationsQ1">O que espera da sua reeducação alimentar?</label>
                      <Field
                        type="text"
                        name="expectationsQ1"
                        id="expectationsQ1"
                        className="fieldInput"
                      />
                      {errors.expectationsQ1 && touched.expectationsQ1 && <div className="error">{errors.expectationsQ1}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="expectationsQ3">Tem alguma preferência ou restrição para o planejamento alimentar?</label>
                      <Field
                        type="text"
                        name="expectationsQ3"
                        id="expectationsQ3"
                        className="fieldInput"
                        placeholder="Ex.: Vegetarianismo, alergias, aversões alimentares..."
                      />
                      {errors.expectationsQ3 && touched.expectationsQ3 && <div className="error">{errors.expectationsQ3}</div>}
                    </div>

                    <div className="consultationLineQuestion">
                      <label htmlFor="expectationsQ2">Está disposto(a) a mudar hábitos alimentares e de estilo de vida?</label>
                      <Field
                        as="select"
                        name="expectationsQ2"
                        id="expectationsQ2"
                        className="fieldInput"
                      >
                        <option value="">Selecione...</option>
                        <option value="totalmente">Totalmente disposto(a)</option>
                        <option value="parcialmente">Parcialmente disposto(a)</option>
                        <option value="dificuldade">Com alguma dificuldade</option>
                        <option value="indeciso">Indeciso(a)/Não tenho certeza</option>
                      </Field>
                      {errors.expectationsQ2 && touched.expectationsQ2 && <div className="error">{errors.expectationsQ2}</div>}
                    </div>
                  </div>
                </Tab>
                {/* Considerações Finais */}
                <Tab label="9 - Considerações Finais">
                  <div className="consultation-form-group">
                    <div className="consultationLineQuestion">
                      <h3 className='askTitle'><span className='askSpan'>9</span> Considerações Finais</h3>
                      <label>Procedimentos:</label>
                      <Field as="textarea" name="procedures" />
                      {errors.procedures && touched.procedures && <div className="error">{errors.procedures}</div>}
                    </div>
                    <div className="consultationLineQuestion">
                      <label>Diagnóstico:</label>
                      <Field as="textarea" name="diagnosis" />
                      {errors.diagnosis && touched.diagnosis && <div className="error">{errors.diagnosis}</div>}
                    </div>
                    <div className="consultationLineQuestion">
                      <label>Observações:</label>
                      <Field as="textarea" name="observations" />
                    </div>
                  </div>
                </Tab>
              </Tabs>

              {/* Campos da Antropometria */}
              <div className="consultation-form-group">

                <h3 className='askTitle'><FaUserDoctor className='icon' /> Antropometria</h3>
                <div className="consultationLine"></div>
                {anthropometryData !== null ? (
                  <div className="consultation-form-group">
                    <ul className="anthropometry-list">
                      <li className="anthropometry-item">
                        <FaCalendar className="icon" />
                        <span>Data: {formatDate(anthropometryData?.measurement_date)}</span>
                      </li>
                      <li className="anthropometry-item">
                        <FaRulerVertical className="icon" />
                        <span>Altura: {anthropometryData?.height} cm</span>
                      </li>
                      <li className="anthropometry-item">
                        <FaWeight className="icon" />
                        <span>Peso Atual: {anthropometryData?.current_weight} kg</span>
                      </li>
                      <li className="anthropometry-item">
                        <FaCalculator className="icon" />
                        <span>IMC: {anthropometryData?.bmi} kg/m²</span>
                      </li>
                      <li className="anthropometry-item">
                        <FaUserMd className="icon" />
                        <span>Classificação: {formatedClassifyBray(anthropometryData?.bray_classification)}</span>
                      </li>
                      <li className="anthropometry-item">
                        <FaPercentage className="icon" />
                        <span>P.G: {anthropometryData?.body_fat_percentage} %</span>
                      </li>
                    </ul>
                    <div className="diet-actions">
                      {/* <button
                        className="sendBtn"
                        type="button"
                        onClick={() => navigate(`/home/anthropometry/update/${currentConsultation.anthropometryData?.[0]?.anthropometry_id}`, {
                          state: {
                            consultation_id: currentConsultation?.consultation_id,
                            patient_id: currentConsultation?.patient_id,
                            appointment_id: currentConsultation?.appointment_id,
                            company_id: currentConsultation?.company_id,
                            professional_id: currentConsultation?.professional_id,
                          }
                        })}
                      >
                        Editar

                      </button> */}

                      {/* // Para deletar antropometria: */}
                      <button
                        className="backBtn"
                        type="button"
                        onClick={() => initiateDelete('anthropometry', anthropometryData?.anthropometry_id)}>
                        Excluir
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="consultationLine">
                      <span className='spanDataTitle'>Dados antropométricos não disponíveis</span>

                      <div className="anthropometryButtons">
                        <button className="sendBtn" type="button" onClick={handleNewAnthropometry}>Nova Antropometria</button>
                        {/* <button className="sendBtn" type="button" onClick={handleAllAnthropometry}>Todas Antropometrias</button> */}
                        {/* <button className="sendBtn" onClick={() => navigate('/anthropometry-evolution')}>Evolução Antropométrica</button> */}
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Campos de Dietas */}
              <div className="consultationLine">
                <div className="consultation-form-group">
                  <h3 className='askTitle'><MdScale className='icon' /> Dietas</h3>
                  <FieldArray name="diets">
                    {({ push }) => (
                      <div>
                        {/* Lista de Dietas */}
                        {values.diets.length > 0 ? (
                          values.diets.map((diet, dietIndex) => (
                            <div key={diet.diet_id || dietIndex} className="diet-box">
                              <div className="consultationLine">
                                <div className="box-diet-col-A">
                                  <div>Nome: <span className="spanDataTitle">{formatDietName(diet.name)}</span></div>
                                  <div>Criada em: <span className="spanDataTitle">{formatDate(diet.created_at)}</span></div>
                                  <div>Objetivo: <span className="spanDataTitle">{diet.objective}</span></div>
                                  <div>Total de Calorias: <span className="spanDataTitle">
                                    {diet.diet_total_calories} kcal/dia
                                  </span></div>
                                </div>

                                {/* Botões para cada dieta */}
                                <div className="diet-actions">
                                  <button
                                    className="sendBtn"
                                    type="button"
                                    onClick={() => navigate(`/home/diet/update/${diet.diet_id}`, {
                                      state: {
                                        consultation_id: currentConsultation?.consultation_id,
                                        patient_id: currentConsultation?.patient_id,
                                        appointment_id: currentConsultation?.appointment_id,
                                        company_id: currentConsultation?.company_id,
                                        professional_id: currentConsultation?.professional_id,
                                        diet_id: diet.diet_id
                                      }
                                    })}
                                  >
                                    Editar
                                  </button>

                                  {/* // Para deletar dieta: */}
                                  <button
                                    className="backBtn"
                                    type="button"
                                    onClick={() => initiateDelete('diet', diet.diet_id)}>

                                    Excluir
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>Nenhuma dieta associada encontrada.</p>
                        )}

                        {/* Botão para adicionar nova dieta (sempre visível) */}
                        <div className="consultationButtons">
                          <button
                            className="sendBtn"
                            type="button"
                            onClick={() => navigate('/home/diet/create', {
                              state: {
                                patient_id,
                                appointment_id,
                                consultation_id,
                                company_id: currentConsultation?.company_id,
                                professional_id: currentConsultation?.professional_id
                              }
                            })}
                          >
                            Criar Nova Dieta
                          </button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>
              </div>

              {/* Alertas de Rodapé */}
              <div className="consultationButtons">
                {errors.consult_date && touched.consult_date && <div className="error">{errors.consult_date}</div>}
                {errors.start_time && touched.start_time && <div className="error">{errors.start_time}</div>}
                {errors.start_time && touched.consultation_type_id && <div className="error">{errors.consultation_type_id}</div>}
                {errors.current_weight && touched.current_weight && <div className="error">{errors.current_weight}</div>}
                {errors.consult_weight && touched.consult_weight && <div className="error">{errors.consult_weight}</div>}
                {errors.objectiveQ1 && touched.objectiveQ1 && <div className="error">{errors.objectiveQ1}</div>}
                {errors.objectiveQ2 && touched.objectiveQ2 && <div className="error">{errors.objectiveQ2}</div>}
                {errors.objectiveQ3 && touched.objectiveQ3 && <div className="error">{errors.objectiveQ3}</div>}

                {errors.foodHistoryQ1 && touched.foodHistoryQ1 && <div className="error">{errors.foodHistoryQ1}</div>}

                {errors.family_history && touched.family_history && (<div className="error-message">{errors.family_history}</div>)}
                {errors.allergies && touched.allergies && (<div className="error-message">{errors.allergies}</div>)}

                {errors.expectationsQ1 && touched.expectationsQ1 && <div className="error">{errors.expectationsQ1}</div>}
                {errors.expectationsQ2 && touched.expectationsQ2 && <div className="error">{errors.expectationsQ2}</div>}
                {errors.expectationsQ3 && touched.expectationsQ3 && <div className="error">{errors.expectationsQ3}</div>}
                {errors.medications && touched.medications && <div className="error">{errors.medications}</div>}

                {errors.emotionalFactorsQ1 && touched.emotionalFactorsQ1 && <div className="error">{errors.emotionalFactorsQ1}</div>}


                {errors.family_history_relation && touched.family_history_relation && <div className="error">{errors.family_history_relation}</div>}
                {errors.family_history_description && touched.family_history_description && <div className="error">{errors.family_history_description}</div>}



                {errors.procedures && touched.procedures && <div className="error">{errors.procedures}</div>}
                {errors.diagnosis && touched.diagnosis && <div className="error">{errors.diagnosis}</div>}
                {errors.observations && touched.observations && <div className="error">{errors.observations}</div>}



                <ErrorMessage name="consultation_type_id" component="div" className="error" />
                <ErrorMessage name="patient_id" component="div" className="error" />
                <ErrorMessage name="appointment_id" component="div" className="error" />
                <ErrorMessage name="company_id" component="div" className="error" />
                <ErrorMessage name="professional_id" component="div" className="error" />
                <ErrorMessage name="diet_id" component="div" className="error" />
              </div>
              {/* Botões  */}
              <div className="consultationButtons">
                <button className="sendBtn" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Atualizando...' : 'Atualizar Consulta'}
                </button>
                <button className="backBtn" type="button" onClick={() => navigate(`/home/consultation/show/${consultation_id}`)}>
                  Voltar
                </button>
              </div>
            </Form>
          )
          }
        </Formik >

      </div >
    </div >
  );
};

export default UpdateConsultation;